import * as React from 'react';

import { $gt } from '@/common/appCtx';
import { useTvMode } from '@/pages/workstation-dashboard/hooks/use-tv-mode';

import GroupPerformance from './components/group-performance';
import WorkstationInfo from './components/workstation-info';
import styles from './index.module.less';

const TvMode = () => {
  const {
    type,
    groupLoading,
    curGroupItem,
    curGroupIndex,
    totalGroups,
    lastUpdateTime,
    workstationListLoading,
    curPage,
    totalPages,
    curWorkstationList
  } = useTvMode();

  const curTitle = React.useMemo(() => {
    if (!curGroupItem || !curGroupItem.workstation_group) return '-';
    return curGroupItem.workstation_group;
  }, [curGroupItem]);

  return (
    <div className={styles.tvMode}>
      <div className={styles.head}>
        <div className={styles.left}>
          <div className={styles.title}>
            {curTitle}&nbsp;
          </div>
          <div className={styles.desc}>
            {$gt('Workstation Group Throughput Dashboard')}
          </div>
          <div className={styles.time}>
            {$gt('Last Update: ')}
            {lastUpdateTime}
          </div>
        </div>
        {totalGroups > 0 && (
          <div className={styles.right}>
            <span>{type === 'single' ? 1 : curGroupIndex + 1}/{totalGroups}&nbsp;</span>
            <span>{$gt('Group')}</span>
          </div>
        )}
      </div>
      <div className={styles.content}>
        <GroupPerformance
          loading={groupLoading}
          curGroupItem={curGroupItem}
        />
        <WorkstationInfo
          loading={workstationListLoading}
          curPage={curPage}
          totalPage={totalPages}
          curWorkstationList={curWorkstationList}
        />
      </div>
    </div>
  );
};

export default TvMode;
